import React, { Component, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';

import exit1 from '../../../assets/icons/exit1.svg';
import Reminder from '../../Reminder/Reminder';
import Duties from '../../Duties/Duties';
import Event from '../../Event/Event';

import './Desktop.css';



export default class Desktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      panel: 1,
    }
  }

  setPanel = (val) => {
    this.setState({
      panel: val,
    })
  }
  render() {
    const { setOpenPanel } = this.props;
    return (
      <div className="panel-box">
        <Fragment>
          <div className="panel__top" onClick={() => setOpenPanel()}></div>
          <div className="panel__right" onClick={() => setOpenPanel()}></div>
          <div className="panel__left" onClick={() => setOpenPanel()}></div>
          <div className="panel__bottom" onClick={() => setOpenPanel()}></div>
          <div className="panel d-flex flex-column">
            <div className="panel__header d-flex">
              <img src={exit1} onClick={() => setOpenPanel()} />
            </div>
            <div className="panel__title">
              <TextField required id="standard-required" placeholder="یک عنوان را وارد کنید" />
            </div>
            <div className="panel__type d-flex">
              <div className="ui buttons d-flex">
                <button className="ui button" id={this.state.panel === 1 ? 'active' : ''} onClick={() => this.setPanel(1)}>یادآوری</button>
                <button className="ui button" id={this.state.panel === 2 ? 'active' : ''} onClick={() => this.setPanel(2)}>رویداد</button>
                <button className="ui button" id={this.state.panel === 3 ? 'active' : ''} onClick={() => this.setPanel(3)}>وظیفه</button>
              </div>
            </div>
            {this.state.panel === 1 ? <Reminder /> : null}
            {this.state.panel === 2 ? <Event /> : null}
            {this.state.panel === 3 ? <Duties /> : null}
            <button className="panel__submit">
              ذخیره
            </button>
          </div>
          {/* {openNumber ? <SettingModal value={phonenumber} valid={validPhonenumber} field={settings[0]} closeModal={closeModal} changeValue={changeValue} /> : null}
          {openEmail ? <SettingModal valid={validEmail} value={email} field={settings[1]} closeModal={closeModal} changeValue={changeValue} /> : null}
          {openUsername ? <SettingModal value={username} valid={validUsername} field={settings[2]} closeModal={closeModal} changeValue={changeValue} /> : null}
          {openPassword ? <SettingModal value={password} value2={password2} valid={validPassword} field={settings[3]} closeModal={closeModal} changeValue={changeValue} /> : null} */}
        </Fragment >
      </div>
    );
  }
}